export const home = {
    "SCHOLASTIC":"Our award-winning Future Traders educational platform offers an engaging, innovative learning experience customizable for students of all levels.",

}